import React from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DateSetter from "../DatePicker";
import moment from "moment";

const getUkTaxYearRanges = (date = moment()) => {
  const taxYearStartYear =
    date.month() > 3 || (date.month() === 3 && date.date() >= 5)
      ? date.year()
      : date.year() - 1;
  const currentTaxYearStart = moment([taxYearStartYear, 3, 5]);

  return {
    current: {
      from: currentTaxYearStart,
      to: moment([taxYearStartYear + 1, 3, 4]),
    },
    last: {
      from: currentTaxYearStart.clone().subtract(1, "year"),
      to: currentTaxYearStart.clone().subtract(1, "day"),
    },
  };
};

const formatDateRange = ({ from, to }) =>
  `${from.format("DD/MM/YYYY")} to ${to.format("DD/MM/YYYY")}`;

const CustomSelect = ({ setFilter, filters, value, setValue, giftAid }) => {
  const dateValue = value.dateValue;
  const format = "DD-MM-YYYY";
  const date = moment();
  const taxYearRanges = getUkTaxYearRanges(date);

  const [secondAnchorEl, setSecondAnchorEl] = useState(null);

  const secondOpen = Boolean(secondAnchorEl);

  const secondHandleClose = () => {
    setSecondAnchorEl(null);
  };

  const applyDateFilter = () => {
    setFilter((prev) => ({
      ...prev,
      date_from: moment(dateValue[0]).format(format),
      date_to: moment(dateValue[1]).format(format),
      page:1
    }));
    secondHandleClose();
  };

  const inputElement = useRef(null);

  const handleChange = (event) => {
    if (event.target.value === "custom") {
      setValue((prev) => ({
        ...prev,
        date_range: event.target.value,
      }));
      setSecondAnchorEl(inputElement.current.node);
      return;
    }

    setValue((prev) => ({
      ...prev,
      date_range: event.target.value,
    }));
    setFilter({ ...filters, date_range: event.target.value });
  };
  
  return (
    <>
      <FormControl>
        <Select
          autoWidth
          size="small"
          inputRef={inputElement}
          value={value.date_range}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <Typography variant="big">Anytime</Typography>;
            }

            if (selected === "custom") {
              return (
                <>
                  <Typography variant="big">{`${moment(dateValue[0]).format(
                    format
                  )}   -   ${moment(dateValue[1]).format(format)}`}</Typography>
                </>
              );
            }

            return selected;
          }}
          sx={{
            borderRadius: "16px",
            "&.Mui-focused": {
              // color:"primary.main",
              // border:"1px solid black",
              "& .MuiOutlinedInput-notchedOutline": {
                boxShadow: "none",
                //used to remove blue styling
                border: "1px solid",
                borderColor: "grey.main",
              },
            },
          }}
          onChange={(event) => handleChange(event)}
          //  open={open}
          id="demo-simple-select"
          //   onChange={handleChange}
        >
          {giftAid && <MenuItem value={"Anytime"}>Anytime</MenuItem>}
          {giftAid && <MenuItem value={"this-month"}>This month</MenuItem>}
          {giftAid && (
            <MenuItem divider value={"last-month"}>
              Last month
            </MenuItem>
          )}
          {giftAid && <MenuItem value={"last-3-month"}>Last 3 months</MenuItem>}
          {giftAid && (
            <MenuItem value={"current-tax-year"}>
              Current tax year/reporting period ({formatDateRange(taxYearRanges.current)})
            </MenuItem>
          )}
          {giftAid && (
            <MenuItem divider value={"last-tax-year"}>
              Last tax year ({formatDateRange(taxYearRanges.last)})
            </MenuItem>
          )}

          {!giftAid && <MenuItem value={"Anytime"}>Anytime</MenuItem>}
          {!giftAid && <MenuItem value={"week"}>In the past week</MenuItem>}
          {!giftAid && (
            <MenuItem divider value={"month"}>
              In the past month
            </MenuItem>
          )}

          <MenuItem
            value={"custom"}
            // component="button"
          >
            Custom range
          </MenuItem>
        </Select>
      </FormControl>
      <Menu
        id="lock-menu"
        anchorEl={secondAnchorEl}
        open={secondOpen}
        onClose={secondHandleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        <Box sx={{ p: "1em" }}>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ maxWidth: "7em", mr: "0.5em" }}>
              <Typography variant="big" fontWeight={500}>
                From
              </Typography>
              <DateSetter
                dateValue={dateValue}
                setDateValue={setValue}
                index={0}
              />
            </Box>
            <Box sx={{ maxWidth: "7em" }}>
              <Typography variant="big" fontWeight={500}>
                To
              </Typography>
              <DateSetter
                dateValue={dateValue}
                setDateValue={setValue}
                index={1}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={applyDateFilter}
              sx={{
                borderRadius: "8px",
                paddingY: "8px",
                paddingX: "12px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "none",
                mt: "1em",
                "&.Mui-disabled": {
                  opacity: "0.3",
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              variant="contained"
              color="primary"
              disableElevation
              disableFocusRipple
              disableRipple
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default CustomSelect;
